import {css} from 'aphrodite';
import React from 'react';

import {styles as fieldActionButtonStyles} from 'metadata/FieldActionButtons';
import SettingsIconDropdown, {SettingsIconDropdownItem} from 'nav/sidepanel/SettingsIconDropdown';
import {TooltipWrapper} from 'ui-library/bs/Tooltip';

export interface AdvancedSettingsDropdownProps {
  options: Array<SettingsIconDropdownItem>;
}

export function AdvancedSettingsDropdown(props: AdvancedSettingsDropdownProps): JSX.Element {
  const dropdownDisabled = props.options.every((option) => option.disabled);
  return (
    <TooltipWrapper tooltipTitle={dropdownDisabled ? 'Advanced settings do not apply to this field' : ''}>
      <SettingsIconDropdown
        options={props.options.filter((option) => !option.disabled)}
        iconClassName={css(fieldActionButtonStyles.singleButton)}
        dropLeft={true}
        disabled={dropdownDisabled}
        dataTestAttrs={{component: 'FieldActionButtons', element: 'settings'}}
      />
    </TooltipWrapper>
  );
}
